import { Link } from "react-router-dom";
import { RequestForFreeTrial } from "./Models";

export default function Footer() {
   const year = new Date().getFullYear();
   return (
      <>
         <div className="footer-bg-wrapper bg-white">
            <div className="bubble-one" />
            <div className="bubble-two" />
            <div className="bubble-three" />
            <div className="fancy-short-banner-two">
               <div className="container">
                  <div className="content-wrapper">

                     <div className="bg-wrapper d-lg-flex align-items-center justify-content-between">
                        <h2>Take a free hands-on experience with TaskFlier</h2>
                        <Link data-bs-toggle="modal" data-bs-target="#request-for-free-trial"> Start Free Trial </Link>
                        <div className="bubble-one" />
                        <div className="bubble-two" />
                        <div className="bubble-three" />
                        <div className="bubble-four" />
                        <div className="bubble-five" />
                     </div>
                  </div>
               </div>
            </div>




            <footer class="theme-footer-one pt-90 md-pt-70">
               <div class="top-footer">
                  <div class="container">
                     <div className="row border-bottom mb-20 align-items-center">
                        <div className="col-md-2 mb-3">
                           <Link to="/" class="logo-main">
                              <img src="/main/images/logo/mnb-project.webp" loading="lazy" alt="Logo Taskflier" />
                           </Link>
                        </div>
                        <div className="col-md-3 mb-3">
                           <div class="d-flex address-icon align-items-center">
                              <div class="icon"><i class="bi bi-telephone"></i></div>
                              <div class="content">
                                 <h4>Tel</h4>
                                 <p class="mb-0"><Link to="tel:+919520053030">+91 95-2005-3030</Link></p>
                              </div>
                           </div>
                        </div>
                        <div className="col-md-3 mb-3">
                           <div class="d-flex address-icon align-items-center">
                              <div class="icon"><i class="bi bi-envelope"></i></div>
                              <div class="content">
                                 <h4>Mail</h4>
                                 <p class="mb-0">support@taskflier.com</p>
                              </div>
                           </div>
                        </div>
                        <div className="col-md-4 mb-3">
                           <div class="d-flex address-icon align-items-center">
                              <div class="icon"><i class="bi bi-geo-alt"></i> </div>
                              <div class="content">
                                 <h4 className="text-dark font-14 fw-600">Address</h4>
                                 <p class=" mb-0">2nd floor G, 75, G Block, Sector 63, Noida, Chotpur, Uttar Pradesh 201309</p>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="row justify-content-start">
                        <div className="col-md-9">

                           <div className="row">
                              <div class="col-lg-3 col-6 col-md-4 footer-list">
                                 <h5 class="footer-title">Company</h5>
                                 <ul>
                                    <li>
                                       <a href="/files/taskflier.pdf" target="blank" download="">
                                          Download </a>
                                    </li>
                                    <li>
                                       <Link to="/about-us">
                                          About us </Link>
                                    </li>
                                    <li>
                                       <Link to="/customers">
                                          Customers</Link>
                                    </li>
                                    <li>
                                       <Link to="/upcomingevent">
                                          upcoming event</Link>
                                    </li>
                                    <li>
                                       <Link to="/our-team">
                                          Our Team</Link>
                                    </li>
                                    <li>
                                       <Link to="/pricing">
                                          Pricing</Link>
                                    </li>
                                    <li>
                                       <Link to="/career">
                                          Career</Link>
                                    </li>
                                    <li>
                                       <Link to="/blog">
                                          Blog</Link>
                                    </li>
                                 </ul>
                              </div>
                              <div class="col-lg-3 col-6 col-md-4 footer-list">
                                 <h5 class="footer-title">Solutions</h5>
                                 <ul>
                                    <li >
                                       <Link to="/solutions/real-estate">
                                          Real Estate</Link>{" "}
                                    </li>
                                    <li >
                                       <Link to="/solutions/chartered-accountant">
                                          CA Management</Link>{" "}
                                    </li>
                                    <li >
                                       <Link to="/solutions/construction">
                                          Construction</Link>{" "}
                                    </li>
                                    <li >
                                       <Link to="/solutions/software-development">
                                          Software Development</Link>{" "}
                                    </li>
                                    <li >
                                       <Link to="/solutions/education">
                                          Education</Link>{" "}
                                    </li>
                                    <li >
                                       <Link to="/solutions/marketing">
                                          Marketing</Link>{" "}
                                    </li>
                                    <li >
                                       <Link to="/solutions/consulting-services">
                                          Consulting Services</Link>{" "}
                                    </li>
                                 </ul>
                              </div>
                              <div class="col-lg-6 col-12 col-md-4 footer-list"
                                 data-aos="fade-up"
                                 data-aos-duration="1200"
                                 data-aos-delay="50"
                              >
                                 <h5 class="footer-title">Features</h5>
                                 <ul className="countul">
                                    <li >
                                       <Link to="/features/theme-customizations">
                                          {" "}
                                          <span>Theme Customizations</span>
                                       </Link>
                                    </li>
                                    <li >
                                       <Link to="/features/task-management-software">
                                          Task Management </Link>
                                    </li>
                                    <li >
                                       <Link to="/features/employee-management-software">
                                          Employee Management </Link>
                                    </li>
                                    <li >
                                       <Link to="/features/client-management-software">
                                          Client Management</Link>
                                    </li>
                                    <li >
                                       <Link to="/features/charts-reporting">
                                          Charts &amp; Reporting</Link>
                                    </li>
                                    <li >
                                       <Link to="/features/attendance-management-software">
                                          Attendance</Link>
                                    </li>
                                    <li >
                                       <Link to="/features/todo-list">
                                          Todo List </Link>
                                    </li>
                                    <li >
                                       <Link to="/features/time-tracking-software">
                                          Time Tracking</Link>
                                    </li>
                                    <li >
                                       <Link to="/features/payment-expense">
                                          Payment & Expense </Link>
                                    </li>
                                    <li >
                                       <Link to="/features/team-chat">
                                          Team Chat </Link>
                                    </li>
                                    <li >
                                       <Link to="/features/appointment">
                                          Appointment</Link>
                                    </li>
                                    <li >
                                       <Link to="/features/lead-management-software">
                                          Leads Management</Link>
                                    </li>
                                    <li >
                                       <Link to="/features/mobile-access">
                                          Mobile Access </Link>
                                    </li>
                                    <li >
                                       <Link to="/features/hr-management-software">
                                          HR Management </Link>
                                    </li>
                                 </ul>
                              </div>
                           </div>

                        </div>


                        <div class="col-lg-3 col-md-4 footer-list">



                           <h5 class="footer-title">Resources</h5>
                           <ul>

                              <li>
                                 <Link to="/cookie-policy">
                                    Cookie Policy</Link>
                              </li>
                              <li>
                                 <Link to="/sitemap.html">
                                    Sitemap</Link>
                              </li>
                              <li>
                                 <Link to="/contact-us">
                                    Contact us </Link>
                              </li>
                           </ul>
                           <h5 class="footer-title mb-0 mt-2">Connect Us</h5>



                           <div class="social-links">
                              <ul class="order-sm-last d-flex">
                                 <li className="mx-0">
                                    <Link to="https://www.facebook.com/profile.php?id=61562909602477" aria-label="facebook" className="social-media" target="blank">
                                       <i class="bi bi-facebook"></i></Link>
                                 </li>
                                 <li>
                                    <Link to="https://www.youtube.com/playlist?list=PL_LnYUXYu7lqozY0i7bzHYx6_oKwDR5PF" aria-label="youtube" className="social-media" target="blank">
                                       <i class="bi bi-youtube"></i></Link>
                                 </li>
                                 <li>
                                    <Link to="https://www.linkedin.com/company/taskflierofficial/?viewAsMember=true" aria-label="linkedin" className="social-media" target="blank">
                                       <i class="bi bi-linkedin"></i></Link>
                                 </li>
                                 <li>
                                    <Link to="https://www.instagram.com/taskflier/" className="social-media" aria-label="instagram" target="blank">
                                       <i class="bi bi-instagram"></i></Link>
                                 </li>


                                 <li><Link to="https://x.com/taskflier" className="social-media" aria-label="twitter-x" target="blank">
                                    <i class="bi bi-twitter-x"></i></Link>
                                 </li>


                              </ul>
                           </div>
                           <h5 class="footer-title mb-0 mt-2">Platforms</h5>



                           <div class="application">
                              <ul class="order-sm-last d-flex">
                                 <li className="mx-0 me-1">
                                    <Link to="https://play.google.com/store/apps/details?id=com.mnb.taskflier_app" className="social-media" target="blank">
                                       <img src="/main/images/Google_Play_Store.webp" loading="lazy" alt="Play Store" /></Link>
                                 </li>
                                 <li className=" me-1">
                                    <Link to="https://apps.apple.com/in/app/taskflier/id6745420979" className="social-media" target="blank">
                                       <img src="/main/images/App_Store.webp" loading="lazy" alt="App Store" /></Link>
                                 </li>
                                 
                                 <li className="">
                                    <a href="/main/images/taskflier-windows.exe" className="social-media" target="blank" download>
                                       <img src="/main/images/windows.webp" loading="lazy" alt="App Store" /></a>
                                 </li>

                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="bottom-footer-content">
                  <div class="container">
                     <div class="d-sm-flex align-items-center justify-content-between">
                        {/* 
            <div class="social-links">
               <ul class="order-sm-last aos-init aos-animate">
                  <li>
                     <Link to="https://www.facebook.com/profile.php?id=61562909602477" className="social-media" target="blank">
                     <i class="bi bi-facebook"></i></Link>
                  </li>
                  <li>
                     <Link to="https://www.youtube.com/playlist?list=PL_LnYUXYu7lqozY0i7bzHYx6_oKwDR5PF" className="social-media" target="blank">
                     <i class="bi bi-youtube"></i></Link>
                  </li>
                  <li>
                     <Link to="https://www.linkedin.com/company/taskflierofficial/?viewAsMember=true" className="social-media" target="blank">
                     <i class="bi bi-linkedin"></i></Link>
                  </li>
                  <li>
                     <Link to="https://www.instagram.com/taskflier/" className="social-media" target="blank">
                     <i class="bi bi-instagram"></i></Link>
                  </li>
               </ul>
            </div>
            */}
                        <ul class="order-sm-last">
                           <li><Link to="/privacy-policy">Privacy</Link></li>
                           <li><Link to="/security">Security</Link></li>
                           <li><Link to="/terms-of-service">Terms</Link></li>
                           <li className="Protect"><a href="//www.dmca.com/Protection/Status.aspx?ID=37f9e236-ce2e-4e5c-b40d-e4a280e383ae" title="DMCA.com Protection Status" class="dmca-badge"> <img src="https://images.dmca.com/Badges/dmca-badge-w200-5x1-06.png?ID=37f9e236-ce2e-4e5c-b40d-e4a280e383ae" loading="lazy" alt="DMCA.com Protection Status" /></a></li>
                        </ul>
                        <p class="order-sm-first">
                           ©  {year} TaskFlier.
Powered by <Link to="https://mnbsoft.com/" target='_blank'>MNB Soft Solution Pvt. Ltd</Link>


                        </p>
                     </div>
                  </div>
               </div>
            </footer>


         </div>
         <RequestForFreeTrial />
      </>
   );
}
